import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LibService } from './libService';

@Injectable({
  providedIn: 'root'
})
export class SubjectIndexesService {

  baseApi = environment.rootApiCrm + 'v1.0';
  constructor(public libService: LibService) { }

  getSubjectIndex(id: string) {
    return this.libService.getData<any>(this.baseApi, `/subjectIndex/${id.toString()}`);
  }

  getAllSubjectIndexes(): Observable<any> {
    console.log(this.baseApi);
    return this.libService.getData<any>(this.baseApi, '/subjectIndexes');
  }

  createSubjectIndex(obj: any) {
    console.log("SERVICE FRONT END INDEX SUBJECT --> ", obj)
    return this.libService.postData<any>(obj, this.baseApi,'/subjectIndex');
  }

  deleteSubjectIndex(idSubject : string, obj: any) {
    return this.libService.deleteData<any>(obj, this.baseApi, `/subjectIndex/${idSubject.toString()}`);
  }

}
